export const DIFFICULTY = Object.freeze({
  HARD: "HARD",
  OKAY: "OKAY",
  EASY: "EASY"
});
